package pl.mothdigital.neuronowi.pages.therapies.terapiaMiofunkcjonalna

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import pl.mothdigital.neuronowi.common.model.*
import pl.mothdigital.neuronowi.components.layouts.*

@Page
@Composable
fun TherapyMiofunctionalPage() {
    TherapyPageLayout(
        content = TherapyPageContent(
            title = "Terapia miofunkcjonalna",
            icon = { FaFaceSmile() },
            description = "Przywracanie równowagi mięśniowej w obrębie jamy ustnej oraz prawidłowych wzorców oddychania i połykania.",
            sections = listOf(
                TherapySection(
                    title = "Czym jest terapia miofunkcjonalna?",
                    content = """
                        Terapia miofunkcjonalna to kompleksowe podejście terapeutyczne, które koncentruje się na przywracaniu
                        prawidłowej równowagi mięśniowej w obrębie twarzy i jamy ustnej. Jej głównym celem jest normalizacja
                        funkcji oddychania, połykania i pozycji spoczynkowej języka, co ma kluczowe znaczenie dla prawidłowego
                        rozwoju twarzoczaszki, zgryzu oraz mowy.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Dla kogo jest terapia miofunkcjonalna?",
                    content = """
                        Terapia miofunkcjonalna jest zalecana dla osób z:

                        • Nieprawidłowym oddychaniem przez usta
                        • Zaburzeniami połykania (dysfagia, infantylny typ połykania)
                        • Nieprawidłową pozycją spoczynkową języka
                        • Wadami zgryzu (zwłaszcza przed i w trakcie leczenia ortodontycznego)
                        • Parafunkcjami (ssanie kciuka, obgryzanie paznokci, zgrzytanie zębami)
                        • Zaburzeniami artykulacji wynikającymi z dysfunkcji mięśniowych
                        • Problemami z karmieniem u niemowląt
                        • Zaburzeniami napięcia mięśniowego w obrębie twarzy
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jakie korzyści przynosi terapia miofunkcjonalna?",
                    content = """
                        Prawidłowo prowadzona terapia miofunkcjonalna może przynieść wiele korzyści:

                        • Normalizację wzorca oddychania nosem
                        • Prawidłowy rozwój twarzoczaszki u dzieci
                        • Poprawę funkcji połykania
                        • Wsparcie leczenia ortodontycznego i zmniejszenie ryzyka nawrotów wad zgryzu
                        • Eliminację szkodliwych nawyków
                        • Poprawę artykulacji
                        • Zmniejszenie napięcia w obrębie stawu skroniowo-żuchwowego
                        • Poprawę jakości snu i zmniejszenie chrapania
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jak przebiega terapia?",
                    content = """
                        Proces terapii miofunkcjonalnej w Centrum Terapii NeuroNowi obejmuje:

                        1. Szczegółową diagnozę - ocenę funkcji mięśni twarzy, języka, warg, funkcji oddychania i połykania.

                        2. Opracowanie indywidualnego programu terapeutycznego.

                        3. Regularne sesje terapeutyczne, podczas których pacjent uczy się świadomego kontrolowania pracy mięśni.

                        4. Zestaw ćwiczeń do wykonywania w domu - kluczowy element terapii zapewniający jej skuteczność.

                        5. Współpracę z innymi specjalistami (ortodontą, logopedą, fizjoterapeutą) w razie potrzeby.

                        6. Regularne wizyty kontrolne i modyfikację programu w zależności od postępów.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasze metody",
                    content = """
                        W terapii miofunkcjonalnej stosujemy różnorodne techniki i narzędia:

                        • Precyzyjnie dobrane ćwiczenia mięśni twarzy, warg i języka
                        • Techniki masażu logopedycznego
                        • Trening prawidłowego oddychania
                        • Reedukację wzorca połykania
                        • Pracę nad eliminacją szkodliwych nawyków
                        • W uzasadnionych przypadkach - wspomaganie terapii specjalistycznymi urządzeniami
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasi specjaliści",
                    content = """
                        Terapię miofunkcjonalną w naszym centrum prowadzą specjaliści z przygotowaniem w zakresie
                        logopedii, ortodoncji miofunkcjonalnej i fizjoterapii. Nasz zespół regularnie poszerza
                        swoją wiedzę, aby zapewnić pacjentom dostęp do najnowocześniejszych i najbardziej
                        skutecznych metod terapeutycznych.
                    """.trimIndent()
                )
            )
        )
    )
}
